import {Controller} from 'stimulus';

const REFRESH_SECONDS = 25;

class AdUnitRefreshController extends Controller {
  static values = {
    unit: String
  }

  connect() {
    setInterval(this.refreshAdUnit, REFRESH_SECONDS * 1000, this.unitValue);

    this.observeStyleChanges(this.element);
  }

  observeStyleChanges = (root) => {
    const adUnitName = root.getAttribute('data-ad-unit-refresh-unit-value');
    const adUnitElement = document.querySelector(`[data-ad-unit-ad-unit="${adUnitName}"]`);

    if (adUnitElement && !adUnitName.endsWith('X')) {
      this.observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'style' && !adUnitElement.style.display.includes('none')) {
            const adUnitFullName = `/2143012/${adUnitElement.getAttribute("data-ad-unit-name")}`;
            const adPositionElement = document.querySelector(`[data-ad-position-id="${adUnitFullName}"]`);
            if (adPositionElement) {
              adPositionElement.style.display = 'none';
            }
          }
        });
      });
      this.observer.observe(adUnitElement, {attributes: true, attributeFilter: ['style']});
    }
  }


  disconnect() {
    clearInterval(this.refreshInterval);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  refreshAdUnit = (adUnitName) => {
    if (!this.isVisible()) {
      return;
    }

    if (document.body.dataset.pageVisibilityActive !== 'true') {
      return;
    }

    let ads = window.MConstants.adUnits[adUnitName];

    if ('googletag' in window) {
      googletag.pubads().refresh(ads);
    } else {
      EventManager.on('google_ad_loaded', () => {
        googletag.pubads().refresh(ads);
      });
    }
  }

  isVisible = () => {
    let ele = this.element;
    const rect = ele.getBoundingClientRect();

    return rect.top >= 0 &&
           rect.left >= 0 &&
           rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
           rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
}

export default AdUnitRefreshController;
